import { useMutation } from '@tanstack/react-query';
import { useApi } from '@tymely/api';
import { QaRejectPayload } from '@tymely/features/Ticket/QaMode/types';

export const useApproveQaMutation = () => {
    const api = useApi();
    return useMutation({
        mutationFn: (argId: number) => api.put(`/argument/${argId}/qa-approve`),
    });
};

export const useQaRejectMutation = () => {
    const api = useApi();
    return useMutation({
        mutationFn: async (update_data: QaRejectPayload) => {
            await api.put(`/argument/${update_data.id}/qa-reject`, {
                update_data,
            });
        },
    });
};

export const useSubmitQaResponse = (objId: number) => {
    const api = useApi();
    return useMutation({
        mutationFn: async (data: { passed: boolean; qa_notes: string }) => {
            await api.post(`/comment/${objId}/response_qa`, data);
        },
    });
};

export const useQaRejectRevertMutation = () => {
    const api = useApi();
    return useMutation({
        mutationFn: async (argId: number) => {
            await api.put(`/argument/${argId}/qa-reject-revert`);
        },
    });
};
